export const htmlEncode = (value) => {
  if (!value) {
    throw new Error(
      'Invalid input: value cannot be falsy (null, undefined, etc.)',
    );
  }
  if (typeof value !== 'string') {
    throw new Error('Invalid input: value must be a string.');
  }

  return value.replace(/[^\w. ]/gi, function (c) {
    return `&#${c.charCodeAt(0)};`;
  });
};

export const jsEscape = (value) => {
  if (!value) {
    throw new Error(
      'Invalid input: value cannot be falsy (null, undefined, etc.)',
    );
  }
  if (typeof value !== 'string') {
    throw new Error('Invalid input: value must be a string.');
  }

  return value.replace(/[^\w. ]/gi, function (c) {
    return `\\u${`0000${c.charCodeAt(0).toString(16)}`.slice(-4)}`;
  });
};
